<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal();">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title v-text="'Ticket '+propEvento.evt_id"></ion-title>

    </ion-toolbar>
  </ion-header>
  <ion-content v-if="vistaModal == 1">
    <ion-grid v-if="cargando" class="ion-text-center ion-margin-top ion-padding-top">
      <ion-row class="ion-justify-content-center ion-margin-top ion-padding-top">
        <ion-col size="12">
          <ion-spinner name="lines" style="width:80px; height:80px;"></ion-spinner>
        </ion-col>
        <ion-col size="12">
          <ion-label color="dark">CARGANDO...</ion-label>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div v-else>
      <div class="container-fluid mt-3">
        <div class="row">
          <div class="col">
            Tipo de evento:
            <div class="alert alert-secondary p-2">
              <h6 v-for="(tipo, index) in evento.tipo" :key="index" v-text="index+1 +' - '+tipo.tev_tipo"></h6>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            Ultima observación:
            <div class="alert alert-secondary p-2">
              <h6 v-if="['', null].includes(evento.estado_actual.hev_observacion)" class="my-auto text-secondary"><i>SIN OBSERVACIONES.</i></h6>
              <h6 v-else class="my-auto" v-text="evento.estado_actual.hev_observacion"></h6>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            Estados del evento:
            <div v-for="(estado, index) in evento.estados" :key="index+'est'" :class="estado.tpe_id == 1 ? 'alert-danger':estado.tpe_id == 2 ? 'alert-warning':estado.tpe_id == 3 ? 'alert-primary':'alert-success'" class="alert p-2">
              <div class="container-fluid p-0">

                <div class="row">
                  <div class="col-5">
                    <h6>Estado</h6>
                  </div>
                  <div class="col">
                    <h6>{{ ': '+estado.tpe_estado }} <span class="font-weight-bold" style="font-size:small;" v-if="index==0">(Estado actual)</span></h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5">
                    <h6>Fecha</h6>
                  </div>
                  <div class="col">
                    <h6>: {{ 
                      estado.hev_fecha_hora.split(' ')[0].split('-')[2] + '/' +
                      estado.hev_fecha_hora.split(' ')[0].split('-')[1] + '/' +
                      estado.hev_fecha_hora.split(' ')[0].split('-')[0] + ' '
                      }}</h6>
                  </div>
                </div>
                <div class="row">
                  <div class="col-5">
                    <h6>Hora</h6>
                  </div>
                  <div class="col">
                    <h6>: {{ 
                      estado.hev_fecha_hora.split(' ')[1].split(':')[0] + ':' +
                      estado.hev_fecha_hora.split(' ')[1].split(':')[1] 
                      }}</h6>
                  </div>
                </div>
                <div v-if="estado.hev_estado==2" class="row">
                  <div class="col-5">
                    <h6>Tiempo estimado</h6>
                  </div>
                  <div class="col">
                    <!--<h6 v-if="estado.hev_tiempo_estimado>=60">: {{ estado.hev_tiempo_estimado/60 }} HORAS.</h6>
                    <h6 v-else>: {{ estado.hev_tiempo_estimado}} MINUTOS.</h6>-->
                    <h6 v-text="calculaTiempoEstimado(estado.hev_tiempo_estimado)"></h6>
                  </div>
                </div>
                <div v-if="estado.hev_estado==2" class="row mt-2">
                  <div class="col-12">
                    <h6>Soporte</h6>
                  </div>
                  <div class="col-12 pl-4 text-muted">
                    <h6>{{ estado.hev_nombres_soporte +' '+estado.hev_apellido_p_soporte }}</h6>
                    <h6>Teléfono: +56 {{estado.telefono}}</h6>
                  </div>
                </div>
                <div class="row" v-if="![4].includes(estado.hev_estado)">
                  <div class="col-12">
                    <h6>Observación </h6>
                  </div>
                  <div class="col-12 pl-4 text-muted">
                    <h6>{{ estado.hev_observacion }}</h6>
                  </div>
                </div>
                <div v-if="estado.fotos.length > 0" class="row">
                  <div class="col-12">
                    <h6>Fotos/Imagenes:</h6>
                  </div>
                  <div class="col-2 text-center" v-for="(foto, index) in estado.fotos" :key="index+'foto'">
                    <ion-thumbnail @click="muestraModalImagen(foto.foe_foto)" style="cursor:pointer;">
                      <img :src="foto.foe_foto">
                    </ion-thumbnail>
                    <!-- <h6 class="text-muted">El usuario no adjuntó fotos/imagenes.</h6> -->
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-content>

  <ion-footer v-if="propEvento.estado_actual.hev_estado == 3 && vistaModal == 1">
    <div class="row my-3 justify-content-center">
      <div class="col-12 text-center">
        <ion-label color="dark">¿El evento fue resuelto?</ion-label>
      </div>
      <div class="col-5">
        <ion-button @click="vistaModal=2;" color="danger" expand="block" shape="round">
          NO
        </ion-button>
      </div>
      <div class="col-5">
        <ion-button @click="muestraAlertConfirmacion();" color="success" expand="block" shape="round">
          SÍ
        </ion-button>
      </div>
    </div>
  </ion-footer>


  <ion-content v-if="vistaModal == 2">
    <div class="container-fluid mt-3">
      <div class="col-12 text-secondary">
          Observaciones:
      </div>
      <div class="col-12">
        <ion-textarea rows="3" cols="20" v-model="observaciones" placeholder="Escribe aquí..."></ion-textarea>
      </div>
    </div>
    
    <div class="row ml-3 mt-2 align-items-center ">
      <ion-toggle v-model="incluyeImagenes" @ionChange="imagenesEvento=[];imagenes=[]" mode="md" color="secondary"></ion-toggle> 
      <span class="text-secondary">Incluir imagenes</span>
      <span v-if="incluyeImagenes" class=" ml-3 my-auto text-success">SÍ</span>
      <span v-else class="ml-3 text-danger">NO</span>
    </div>

    <div v-if="incluyeImagenes" class="row mt-2 justify-content-center">
      <div class="col-6 text-center px-1">
        <ion-button @click="subirImagen()" color="primary" shape="round" fill="outline"><fa icon="image-polaroid" type="fad" class="fa-fw mr-1"></fa>SUBIR FOTO</ion-button>
      </div>
      <div v-if="esMovil" class="col-6 text-center px-0">
        <ion-button @click="tomarImagen()" color="primary" shape="round" fill="outline"><fa icon="camera" type="fad" class="fa-fw mr-1"></fa>TOMAR FOTO</ion-button>
      </div>
      <div class="col-12 text-center">
        <!-- ACA IRIAN LAS FOTOS -->
        <div v-if="imagenes.length>0" class="row mb-2 justify-content-center">
          <div class="col-3 mx-1 mt-2 pb-3 shadow-sm" :id="'foto'+index" :key="foto" v-for="(foto, index) in imagenes">
            <div class="cursor-pointer" @click.stop.prevent="eliminaFoto('foto'+index, index);">
              <fa icon="times-square" type="fas" class="my-2 float-left text-danger"></fa>
            </div>
            <img :src="foto.webviewPath">
          </div>
        </div>
      </div>
    </div>
  </ion-content>

  <ion-footer v-if="!cargando && propEvento.estado_actual.hev_estado == 3 && vistaModal == 2">
    <div class="row my-3 justify-content-center">
      <div class="col-5">
        <ion-button @click="vistaModal=1;" color="danger" expand="block" shape="round">
          CANCELAR
        </ion-button>
      </div>
      <div class="col-5">
        <ion-button :disabled=" observaciones == '' ||  (incluyeImagenes && imagenes.length==0)" 
            @click.stop.prevent="modificarEventoComoSinResolver();" color="success" expand="block" shape="round">
          ACEPTAR
        </ion-button>
      </div>
    </div>
  </ion-footer>
</template>

<script>
import { modalController, toastController, alertController, loadingController, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow,IonGrid, IonSpinner, IonLabel, IonThumbnail, IonTextarea, IonToggle} from '@ionic/vue';
import { defineComponent      } from 'vue';
import { addIcons             } from 'ionicons';
import { arrowBackOutline, trashOutline, settingsOutline } from 'ionicons/icons';
import { cerrarSesion         } from '@/plugins/funciones.ts';
import { Preferences          } from '@capacitor/preferences';
import { tomarFoto, subirFoto } from '@/plugins/usarCamara';
import axios                    from 'axios';
import * as $                   from "jquery";
import rutaBase                 from '@/plugins/variables';

import mImagen from '../../components/ModalImagen.vue';

export default defineComponent({
  name: 'VerEvento',
  components: { IonContent, IonFooter, IonHeader,  IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, IonSpinner, IonLabel,  IonThumbnail,IonTextarea, IonToggle },
  props: {
    propEvento  : Object,
    esMovil     : Boolean
  },
  
  data(){
    return {
      cargando          : true,
      evento            : {},
      rutUsuario        : null,
      vistaModal        : 1,
      observaciones     : '',
      ModalImagen       : null,
      incluyeImagenes   : false,
      imagenesEvento    : [],
      imagenes          : [],
      idImagenBorrar    : '',
      indiceImagenBorrar: '',
      cargandoTodo      : null
    }
  },
  created() {
    addIcons({
      'arrow-back-outline'  : arrowBackOutline,
      'trash-outline'       : trashOutline,
      'settings-outline'    : settingsOutline
    });
  },
  mounted(){
    this.datosUsuario();
    this.listarEventoConDetalles();
  },
  methods:{

    async cargandoDatosTotal() {
      this.cargandoTodo = await loadingController
        .create({
          cssClass: 'text-secondary',
          message: 'CARGANDO DATOS...',
          animated:false,
          mode:'md'
        });
      await this.cargandoTodo.present();
    },

    async datosUsuario(){
      const rut       = await Preferences.get({ key: 'rut' });
      this.rutUsuario = rut.value;
    },

    async listarEventoConDetalles(){
      this.cargando = true;
      const dato  = new URLSearchParams();
      dato.append('id_evento', this.propEvento.evt_id);
      const token   = await Preferences.get({ key: 'token_auth' });
      const headers = { headers: { 'Authorization': `${token.value}` } };
      axios.post(rutaBase+'/normal/listarEventoConDetalles', dato, headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.evento = resp.data.evento;
        }
        this.cargando = false;
      }).catch(() =>{
        this.cargando = false;
        this.muestraToast('ERROR AL CONECTARSE CON EL SERVIDOR.');
      });
    },

    async modificarEventoComoSinResolver(){
      await this.cargandoDatosTotal();
      await this.ajustaFotosCamara();
      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data  = new URLSearchParams();
      data.append('evento',         this.propEvento.evt_id);
      data.append('observaciones',  this.observaciones);
      data.append('imagenes',       JSON.stringify(this.imagenesEvento));

      axios.post(rutaBase+'/normal/modificarEventoComoSinResolver',data,headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.cargandoTodo.dismiss();
          if(resp.data == 1){
            this.cerrarModal({respuesta:1, msj:'EL EVENTO SE HA VUELTO A REPORTAR.'});
          }
          else{
            this.cerrarModal({respuesta:2});
          }
        }
      }).catch(() =>{
        this.cargandoTodo.dismiss();
        this.cerrarModal({respuesta:3});
      });
    },

    async muestraAlertConfirmacion() {
      const alert = await alertController
        .create({
          cssClass: 'text-justify',
          header: 'Confirmar elección',
          message: 'Si acepta, el evento aparecerá en la sección historial.',
          buttons: [
            {
              text: 'CANCELAR',
              handler: () => {
                //No se borra
              },
            },
            {
              text: 'ACEPTAR',
              handler: () => {
                this.modificarEventoComoResuelto();
              },
            },
          ],
        });
      return alert.present();
    },

    async modificarEventoComoResuelto(){
      await this.cargandoDatosTotal();

      const token       = await Preferences.get({ key: 'token_auth' });
      const headers     = { headers: { 'Authorization': `${token.value}` } };
      const data  = new URLSearchParams();
      data.append('evento',         this.propEvento.evt_id);
      axios.post(rutaBase+'/normal/modificarEventoComoResuelto',data,headers).then( resp => {
        if(resp.status == 203) { cerrarSesion(); }
        else{
          this.cargandoTodo.dismiss();
          if(resp.data == 1){
            this.cerrarModal({respuesta:1, msj:'EVENTO CONFIRMADO COMO RESUELTO.'});
          }
          else{
            this.cerrarModal({respuesta:2});
          }
        }
      }).catch(() =>{
        this.cargandoTodo.dismiss();
        this.cerrarModal({respuesta:3});
      });
    },


    calculaTiempoEstimado(tiempo){
      let tiempoEstimado = '';
      if(tiempo<60){
        tiempoEstimado = ": "+tiempo+" Minutos.";
      }
      else if(tiempo==60){
        tiempoEstimado = ": 1 HORA.";
      }
      else if(tiempo>60){
        tiempoEstimado = ": "+tiempo/60+" Horas";
      }
      return tiempoEstimado; 
    },

    async muestraModalImagen(imagen){
      this.modalImagen = await modalController
        .create({
          component       : mImagen,
          componentProps  : {
            imagen        : imagen,
            modal         : this.modalImagen
          }
        });
      this.modalImagen.present();
      const modalResponse = await this.modalImagen.onDidDismiss();
      modalResponse.data && this.modalCloseHandler({...modalResponse.data})
    },

    modalCloseHandler(_value) {
      const datos = _value;
      console.log(datos);
    },

    formateaNumero(numero){
      return new Intl.NumberFormat("de-DE").format(numero)
    },

    async cerrarModal(dato=null){
      modalController.dismiss(dato);
    },

    async muestraToast(msj='') {
      const toast = await toastController
        .create({
          message: msj,
          duration: 2000,
          cssClass: 'text-center'
        })
      return toast.present();
    },


    /*************************************/
    /* FUNCIONES PARA MANEJO DE IMAGENES */
    /*************************************/
    async tomarImagen(){
      const foto = await tomarFoto();
      this.imagenes.push(foto);
    },

    async subirImagen(){
      const foto = await subirFoto();
      this.imagenes.push(foto);
    },

    async resizeImg(base64) {
      const ancho = 720;
      const alto  = 1280;
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      const deferred = $.Deferred();
      let escala = 0;
      $("<img>").attr("src", base64).on("load", function() {
          let width, height;
          if(this.width < this.height){
            width   = ancho;
            height  = alto;
          }else{
            width   = alto;
            height  = ancho;
          }
          if(width/this.width < height/this.height){
            escala = width/this.width;
          }else{
            escala = height/this.height;
          }
          canvas.width  = this.width*escala;
          canvas.height = this.height*escala;

          context.scale(escala, escala);
          context.drawImage(this, 0, 0);
          deferred.resolve(canvas.toDataURL());
      });
      return deferred.promise();
    },

    eliminaFoto(id,indice){
      console.log(id)
      console.log(indice)
      this.idImagenBorrar = id;
      this.indiceImagenBorrar = indice;
      this.muestraAlertEliminacion();
    },

    async muestraAlertEliminacion() {
      const alert = await alertController
        .create({
          cssClass: 'my-custom-class',
          header: 'Confirmar',
          message: '¿DESEA ELIMINAR LA IMAGEN SELECCIONADA?',
          buttons: [
            {
              text: 'CANCELAR',
              handler: () => {
                this.idImagenBorrar     = '';
                this.indiceImagenBorrar = '';
              },
            },
            {
              text: 'ACEPTAR',
              handler: () => {
                this.imagenes.splice(this.indiceImagenBorrar, 1)
                $("#"+this.idImagenBorrar).remove();
                this.idImagenBorrar     = '';
                this.indiceImagenBorrar = '';
              },
            },
          ],
        });
      return alert.present();
    },

    async ajustaFotosCamara(){
      const fotosCamara = [];
      this.imagenes.forEach( function(valor) {
        fotosCamara.push(valor.webviewPath)
      });
      for(let i=0;i<fotosCamara.length;i++){
        await this.resizeImg(fotosCamara[i]).then(img => {
          this.imagenesEvento.push(img);
        });
      }
    }
  }
});
</script>

<style scoped>
.primary{
  color: #3880ff;
}

.rounded-border {
  border:2px solid black;
  color:black; 
  padding:6px; 
  border-radius:15px; 
  margin-right:2px;
}

.cards {
  min-height: 150px;
  border-radius: 15px; 
  margin: 0;
  /* background-color: white !important; */
  border: 2px solid black !important;
}

.fondo{
  /* background-color: white !important; */
  height: 100% !important;
}
</style>